<div class="modal-header">
    <h4 class="modal-title">Actualizar Categoría</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <div class="row d-flex align-items-center">

            <div class="mb-3 col-12 col-sm">
                <label for="nombre">Nombre</label>
                <input type="text" class="form-control" id="nombre" formControlName="nombre"
                    [ngClass]="{'is-invalid': form.controls['nombre'].errors && form.controls['nombre'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo.
                </div>
            </div>
        </div>
        <div class="mb-3 col-12 col-sm">
            <label for="categoria_padre">Categoría Padre</label><label class="campo-opcional">(Opcional)</label>
            <ng-select  [(ngModel)]="seleccionado" [items]="categorias" bindLabel="nombre" bindValue="id"
                formControlName="categoria_padre_id" >
            </ng-select>
            <div class="invalid-feedback">
                Debe ingresar un valor en el campo.
            </div>
        </div>
        <div class="mb-3 col-12 col-sm">
            <label for="descripcion">Descripción</label><label class="campo-opcional">(Opcional)</label>
            <textarea class="form-control" id="descripcion" formControlName="descripcion" rows="3"
                [ngClass]="{'is-invalid': form.controls['descripcion'].errors && form.controls['descripcion'].touched}"></textarea>
            <div class="invalid-feedback">
                Debe ingresar un valor en el campo.
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="guardar()">Actualizar</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancelar</button>
</div>